import React, { useState, useEffect } from "react";
import "./FacultyPrograms.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const FacultyPrograms = () => {
  const years = [ "2026-27","2025-26","2024-25", "2023-24", "2022-23", "2021-22", "2020-21", "2019-20"];

  const yearData ={

  "2026-27": {
    "title": "AI, Metaverse & Smart Digital Skills: Shaping the Future of Learning and Innovation",
    "duration": "6 Days",
    "dates": "18 - 23 January 2027",
    "audience": "Faculty Members",
    "mode": "Offline",
    "overview1": "This Faculty Development Program (FDP) aims to equip educators with comprehensive knowledge of Artificial Intelligence (AI), the Metaverse, and advanced digital skills to enhance modern teaching and learning practices. Through expert sessions, case studies, and hands-on activities, participants will explore AI-driven education, immersive virtual environments, and innovative digital tools.",
    "patrons": [
      "Shri. V. K. Singh (Chairman, Thakur Educational Trust)",
      "Shri. Jitendra Singh (Secretary, Thakur Educational Trust)"
    ],
    "convener": [
      "Dr. Pravin Gundalwar, Director, TIMSCDR",
      "Prof. Sonu Gupta, Dy. Director, TIMSCDR"
    ],
    "coordinator": [
      "Dr. Sonal Sharma",
      "Dr. Padma Mishra"
    ],
    "organizingCommittee": [
      "Dr. Rajesh Kapur",
      "Dr. Ashwini Renavikar",
      "Ms. Sunita Pachpute",
      "Dr. Aaditya Desai",
      "Ms. Rani Singh",
      "Ms. Kinjal Doshi",
      "Ms. Rashmi Vipat",
      "Ms. Rupali Jadhav",
      "Mr. Shirshendu Maitra",
      "Ms. Aprajita Singh",
      "Mr. Brijesh Pandey",
      "Ms. Anamika Dhawan",
      "Ms. Rohini Bagul",
      "Ms. Shweta Waghmare",
      "Ms. Thara C.",
      "Ms. Alifiya Shaikh",
      "Ms. Mira Gohil",
      "Dr. Shiksha Dubey",
      "Mr. Santosh Jain",
      "Mr. Shubham Mishra",
      "Ms. Sweety Sahani",
      "Ms. Anusri Mukhopadhyay",
      "Ms. Vaishnavi Biradar",
      "Ms. Melissa Fernandes",
      "Ms. Ariba Akhtar"
    ],
    "aboutAtal": "ATAL Academy (AICTE Training and Learning Academy) is an initiative of the All India Council for Technical Education (AICTE) launched to improve the quality of technical education in India by building the capacities of teachers, researchers, and technical staff through short-term FDPs in emerging domains.",
    "fdpCourseContent": [
      "AI in Teaching, Learning & Research - Evolution of education and real-world AI applications in academia and industry.",
      "Smart Digital Skills & Prompt Engineering - Effective use of digital tools and generative AI for teaching and research.",
      "Ethical & Responsible AI - Ethical AI, privacy, data governance, and responsible digital learning ecosystems.",
      "Human-AI Collaboration & Industry 5.0 - Future of jobs, employability, human-centric innovation, and future-ready skills.",
      "Quantum Technologies - Fundamentals of quantum simulators and accelerators and their emerging applications.",
      "Metaverse & Immersive Learning - Exploring and creating basic Metaverse spaces for innovative and engaging learning."
    ],
    "sessions": [
      {
        "dayTitle": "18 January 2027",
        "points": [
          "From Chalkboards to Chatbots: Evolution of Teaching and Learning | Dr. S. S. Mantha, Chancellor and President of Ramdeobaba University (RBU) Nagpur, Former Chairman AICTE",
          "Quantum Simulators and Accelerators | Dr. Amit Saxena, Scientist-F (Associate Director), C-DAC"
        ]
      },
      {
        "dayTitle": "19 January 2027",
        "points": [
          "Bridging academic concepts with real-world AI applications | Dr. Goutam Das, Founder and Chief Data Scientist, InsAnalytics",
          "Smart Digital Skills for Future Academicians and Researchers | Dr. Ketan Shah, Professor & Associate Dean (Accreditation), NMIMS"
        ]
      },
      {
        "dayTitle": "20 January 2027",
        "points": [
          "Prompt Engineering for Teachers and Researchers | Dr. Sheetal Rathi, Professor (Computer Engineering) & HoD (Post Graduation) Computer Engineering, TCET",
          "Designing AI-Driven Digital Learning Ecosystems with Ethical Foundations | Dr. Saurabh Pramanick, Data Governance Officer (DGO) - Data Office - Information Security Office - Risk Management, Bank Muskut"
        ]
      },
      {
        "dayTitle": "21 January 2027",
        "points": [
          "Human Vs AI - Will AI replace Jobs or create new ones | Mr. Prashant Pandey, Global Solution - AI and Automation, bp (British Petroleum)",
          "Industry 5.0 and Employability Skills | Mr. Pravin Mane, Game Programmer and Immersive Tech Expert, Capgemini"
        ]
      },
      {
        "dayTitle": "22 January 2027",
        "points": [
          "Industrial Visit"
        ]
      },
      {
        "dayTitle": "23 January 2027",
        "points": [
          "Hands-on: Creating a Basic Metaverse Space | Mr. Dipen Visavadia, Senior Vice President and Enterprise Architect, Publicis Groupe",
          "Valedictory"
        ]
      }
    ],
    "tools": [
      "AI IN TEACHING",
      "METAVERSE",
      "SMART DIGITAL SKILLS",
      "PROMPT ENGINEERING",
      "INDUSTRY 5.0",
      "QUANTUM TECHNOLOGIES"
    ],
    "registrationDetails": {
      "fee": "Nil",
      "lastDate": "10 January 2027",
      "selection": "First-come, first-served basis (50 participants only)",
      "nomination": "Participants must be nominated by their Principal/Director/Registrar.",
      "portalSteps": [
        "Register on the AICTE ATAL Portal: https://www.aicte-india.org/atal",
        "Create a Participant Account (if not already registered) and log in.",
        "Search for the FDP titled 'AI, Metaverse & Smart Digital Skills: Shaping the Future of Learning and Innovation' (ATAL FDP ID: 5390, Application Number: 177562723).",
        "Upload required documents: Institution ID Card and No Objection Certificate (NOC) from the Principal/Director/Registrar.",
        "After successful registration, kindly email the Registration Form and NOC to sonal@timscdrmumbai.in and padma.mishra@timscdrmumbai.in"
      ]
    },
    "contacts": [
      "Dr. Sonal Sharma: 9904466440",
      "Dr. Padma Mishra: 90287 70774"
    ],
    "outcome": "Faculty will be empowered to design engaging, inclusive, and technology-enabled learning experiences, preparing students effectively for the rapidly evolving digital world and workforce demands globally today."
  },

    "2025-26": {
      "title": "AI-Enabled Teaching, Learning Analytics, NEP 2020 & Student-Centric Pedagogies",
      "duration": "20 Days",
      "dates": "January 12 – 31, 2026",
      "audience": "Faculty Members",
      "mode": "Hybrid",
      "overview1": "The program covered AI-enabled teaching tools, learning analytics, NEP 2020 and NCrF-aligned pedagogies, AI-driven assessment practices, and institutional examination policies, along with sessions on faculty well-being and financial awareness.",
      "sessions": [
        {
          "dayTitle": "AI Tools & Learning Analytics in Pedagogy",
          "points": [
            "AI-enabled teaching tools and learning analytics for modern classrooms",
            "NEP 2020 and NCrF-aligned student-centric pedagogies"
          ]
        },
        {
          "dayTitle": "Assessment Practices & Institutional Policies",
          "points": [
            "AI-driven assessment practices and institutional examination policies",
            "Practical faculty presentations on CO-PO mapping and assessment alignment"
          ]
        },
        {
          "dayTitle": "Faculty Development & Well-being",
          "points": [
            "Interactive expert sessions on faculty well-being and financial awareness",
            "Expert insights delivered by Dr. Rizwana Siddiqui, Dr. Deepti Reddy, and distinguished speakers"
          ]
        },
        {
          "dayTitle": "Valedictory Function & Implementation Plan",
          "points": [
            "Reflections on program outcomes and future teaching-learning implementation",
            "Valedictory Function celebrating successful program completion"
          ]
        }
      ],
      "tools": [
        "AI-ENABLED TEACHING",
        "LEARNING ANALYTICS",
        "NEP 2020",
        "CO-PO MAPPING",
        "ASSESSMENT TOOLS"
      ],
      "outcome": "Faculty gained practical expertise in AI tools, student-centric pedagogies, and outcome-based assessment alignment for enhanced classroom execution."
    },
    "2024-25": {
      "title": "Revolutionizing Healthcare: Integrating AI for Effective Solutions",
      "duration": "5 Days",
      "dates": "January 6 – 10, 2025",
      "audience": "Faculty Members",
      "mode": "Hybrid",
      "overview1": "The FDP focused on fostering innovation and expertise in healthcare technology through AI tools like MATLAB. The program included expert sessions, hands-on workshops, and discussions on real-world healthcare challenges and solutions.",
      "sessions": [
        {
          "dayTitle": "Day 1: AI in Healthcare & Molecular Structures Analysis",
          "points": [
            "Molecular structures for disease prediction",
            "AI's role in healthcare advancements and ethical considerations"
          ]
        },
        {
          "dayTitle": "Day 2-3: Deep Learning with MATLAB",
          "points": [
            "Image and audio processing using MATLAB",
            "Bounding boxes and advanced feature extraction",
            "Hands-on experience on deep learning applications"
          ]
        },
        {
          "dayTitle": "Day 4: Machine Learning in Everyday Life",
          "points": [
            "Automation applications across industries",
            "Improving efficiency through machine learning"
          ]
        },
        {
          "dayTitle": "Day 5: Healthcare Innovation & Valedictory",
          "points": [
            "Keynote address on healthcare innovation",
            "Faculty presentations and Valedictory Function"
          ]
        }
      ],
      "tools": [
        "MATLAB",
        "DEEP LEARNING",
        "AI/ML",
        "HEALTHCARE",
        "IMAGE PROCESSING"
      ],
      "outcome": "Faculty gained insights, enhanced skills, and explored AI-enabled solutions to real-world healthcare challenges."
    },
    "2023-24": {
      "title": "Microsoft Power BI Workshop",
      "duration": "2 Days",
      "dates": "17 – 18 January, 2024",
      "audience": "Faculty Members",
      "mode": "Offline",
      "overview1": "TIMSCDR organized a Faculty Development Program on Microsoft Power BI to equip faculty with practical business intelligence and dashboarding skills.",
      "sessions": [
        {
          "dayTitle": "Day 1: Data Modelling & Visualization",
          "points": [
            "Data importation and transformation.",
            "Dashboard creation and report building."
          ]
        },
        {
          "dayTitle": "Day 2: Advanced Power BI Techniques",
          "points": [
            "Intermediate DAX functions.",
            "Publishing and collaboration workflows."
          ]
        }
      ],
      "tools": [
        "POWER BI",
        "DAX",
        "DATA MODELLING",
        "DASHBOARDS"
      ],
      "outcome": "Faculty members learned to build, publish, and interpret professional business intelligence dashboards using Power BI."
    }
  }

  // Timeline data for the sidebar matching the image
const timelineData = [
  {
    year: "2025-26",
    title: "AI-Enabled Teaching, Learning Analytics, NEP 2020 & Student-Centric Pedagogies",
    desc: "Twenty-day FDP covering AI tools, NEP 2020 pedagogies, assessment practices, and faculty well-being.",
    iconPath: "M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0112 20.055a11.952 11.952 0 01-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
  },
  {
    year: "2024-25",
    title: "Revolutionizing Healthcare: Integrating AI for Effective Solutions",
    desc: "Five-day FDP focused on AI tools like MATLAB for disease prediction, deep learning, and healthcare solutions.",
    iconPath: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
  },
  {
    year: "2023-24",
    title: "Microsoft Power BI Workshop",
    desc: "Two-day FDP on Microsoft Power BI in association with Computer Society of India.",
    iconPath: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
  },
  {
    year: "2022-23",
    title: "Robotic Process Automation",
    desc: "Two-day FDP on RPA using UiPath in association with FOSLIPY.",
    iconPath: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
  },
  {
    year: "2021-22",
    title: "Blockchain Technology & Applications",
    desc: "Faculty Development Program exploring distributed ledger technology and smart contracts.",
    iconPath: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
  },
  {
    year: "2020-21",
    title: "Data Analytics & Machine Learning",
    desc: "Comprehensive sessions on algorithmic modeling and predictive analytics tools.",
    iconPath: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  },
  {
    year: "2019-20",
    title: "Machine Learning with R",
    desc: "Hands-on FDP on statistical modeling and machine learning applications using R.",
    iconPath: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  }
];

  // Carousel Image Array based on the uploaded image directory
const carouselImages = [

  "/FDP/IMG_1749.JPG",
  "/FDP/MCA02122.JPG",
  "/FDP/MCA02152.JPG",
  "/FDP/MCA02587.JPG",
  "/FDP/MCA02589.JPG",
  "/FDP/imgi_3_WhatsApp-Image-2025-01-09-at-1.43.26-PM.webp",
  "/FDP/imgi_4_1736509782303-1-1-scaled.webp",
  "/FDP/imgi_5_1736509781981-scaled.webp",
  "/FDP/imgi_6_1736509781739-scaled.webp",
  "/FDP/imgi_7_FDP-23-scaled.webp",
  "/FDP/imgi_8_FDP_24-scaled.webp",
  "/FDP/imgi_9_FDP_23-scaled.webp",
  "/FDP/imgi_10_FDP2023.webp",
  "/FDP/imgi_11_FDP-Day-1.webp",
  "/FDP/imgi_12_FDP-Day-1-1.webp",
  "/FDP/imgi_13_FDP-Day-2.webp",
  "/FDP/imgi_14_FDP-2021-New.webp",
  "/FDP/imgi_15_FDP-2021-New1.webp",
  "/FDP/imgi_16_01-FDP-blockchain-2021-copy.webp",
  "/FDP/imgi_17_02-FDP-blockchain-2021-copy.webp",
  "/FDP/imgi_18_07-FDP-blockchain-2021-copy.webp",
  "/FDP/imgi_19_08-FDP-blockchain-2021-copy.webp",
  "/FDP/imgi_20_01-FDP-Machine-Learning-with-R-2019.webp",
  "/FDP/imgi_21_02-FDP-Machine-Learning-with-R-2019.webp",
  "/FDP/imgi_22_03-FDP-Machine-Learning-with-R-2019.webp",
  "/FDP/imgi_23_04-FDP-Machine-Learning-with-R-2019.webp",
  "/FDP/imgi_24_05-01-Python-Workshop-December-2018.webp",
  "/FDP/imgi_25_06-02-Python-Workshop-December-2018.webp"
];

  const [activeYear, setActiveYear] = useState("2026-27");
  const [currentSlide, setCurrentSlide] = useState(0);

  // Default to 2024-25 if data for clicked year is missing in the abbreviated object
  const current = yearData[activeYear] || yearData["2026-27"];

  // Carousel Auto-play logic
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500); // Change image every 3.5 seconds

    return () => clearInterval(slideInterval);
  }, [carouselImages.length]);

  return (
    <>
      <Navbar />
      <PageHeader
        title="Faculty Development Programmes (FDPs)"
        crumbs={[
          { label: 'Home', href: '/' },
          { label: 'FDP', href: '/faculty-development-programs' }
        ]}
      />
      
      <div className="fdp-page-root">
        <div className="fdp-page-container">

          {/* HERO SECTION */}
          <div className="fdp-hero-wrapper">
            <div className="fdp-hero-left">
              <div className="fdp-hero-text">
                Our Faculty Development Programmes (FDPs) are designed to enhance the knowledge and skills
                of our faculty members in alignment with the latest advancements in the MCA syllabus of
                Mumbai University. These FDPs cover a wide range of topics, ensuring our educators are
                well-equipped to provide high-quality education to students pursuing their MCA degrees.
              </div>

              <div className="fdp-stats-container">
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">05+</span>
                    <span className="fdp-stat-label">FDPs Conducted</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">2019-25</span>
                    <span className="fdp-stat-label">Academic Years</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">100+</span>
                    <span className="fdp-stat-label">Faculty Members Benefited</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">Industry Relevant</span>
                    <span className="fdp-stat-label">Skills & Technologies</span>
                  </div>
                </div>
              </div>
            </div>

            {/* REPLACED ILLUSTRATION WITH IMAGE CAROUSEL */}
            <div className="fdp-hero-right">
              <div 
                className="fdp-hero-carousel" 
                style={{ 
                  position: 'relative', 
                  width: '100%', 
                  height: '350px', // Adjust height as necessary to match your layout
                  borderRadius: '16px', 
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.15)',
                  backgroundColor: '#f1f5f9'
                }}
              >
                {carouselImages.map((imgSrc, idx) => (
                  <img 
                    key={idx}
                    src={imgSrc} 
                    alt={`FDP Highlight ${idx + 1}`}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', // Ensures the image fills the area gracefully without stretching
                      opacity: currentSlide === idx ? 1 : 0,
                      transition: 'opacity 0.8s ease-in-out',
                      zIndex: currentSlide === idx ? 1 : 0
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* YEAR TABS */}
          <div className="fdp-year-nav">
            {years.map((year) => (
              <button
                key={year}
                type="button"
                className={
                  activeYear === year
                    ? "fdp-year-btn fdp-year-btn-active"
                    : "fdp-year-btn"
                }
                onClick={() => setActiveYear(year)}
              >
                {year}
              </button>
            ))}
          </div>

          {/* MAIN CONTENT & SIDEBAR */}
          <div className="fdp-main-grid">

            {/* Left Main Card */}
            <div className="fdp-main-card">
              <div className="fdp-main-title">{current.title}</div>

              {/* Meta info tags */}
              <div className="fdp-meta-grid">
                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Duration:</span>
                  <span className="fdp-meta-value">{current.duration}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Date:</span>
                  <span className="fdp-meta-value">{current.dates}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Audience:</span>
                  <span className="fdp-meta-value">{current.audience}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Mode:</span>
                  <span className="fdp-meta-value">{current.mode}</span>
                </div>
              </div>

              {/* Overview */}
              <div className="fdp-section">
                <div className="fdp-section-title">Overview</div>
                <div className="fdp-section-text">{current.overview1}</div>
                {current.overview2 && <div className="fdp-section-text">{current.overview2}</div>}
              </div>

              {/* Sessions */}
              <div className="fdp-section">
                <div className="fdp-section-title">Key Sessions / Topics Covered</div>
                <div className="fdp-session-list">
                  {current.sessions.map((session, idx) => (
                    <div key={idx} className="fdp-session-block">
                      <div className="fdp-session-day-title">
                        {session.dayTitle}
                      </div>
                      <ul className="fdp-session-ul">
                        {session.points.map((pt, i) => (
                          <li key={i} className="fdp-session-li">
                            {pt}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tools */}
              <div className="fdp-section">
                <div className="fdp-section-title">Tools & Technologies Used</div>
                <div className="fdp-tools-row">
                  {current.tools.map((tool) => (
                    <span key={tool} className="fdp-tool-chip">
                      {tool}
                    </span>
                  ))}
                </div>
              </div>

              {/* Outcome */}
              <div className="fdp-outcome-box">
                <div className="fdp-outcome-text">
                  {current.outcome}
                </div>
              </div>
            </div>

            {/* Right Sidebar Timeline */}
            <div className="fdp-timeline-sidebar">
              <div className="fdp-timeline">
                {timelineData.map((item, index) => (
                  <div key={index} className="fdp-timeline-item">
                    <div className="fdp-timeline-icon">
                      <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d={item.iconPath}></path>
                      </svg>
                    </div>
                    <div className="fdp-timeline-content">
                      <div className="fdp-timeline-year">{item.year}</div>
                      <div className="fdp-timeline-title">{item.title}</div>
                      <div className="fdp-timeline-desc">{item.desc}</div>
                      <button className="fdp-view-details" onClick={() => setActiveYear(item.year)}>
                        View Details
                        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FacultyPrograms;